import { createSlice } from '@reduxjs/toolkit';

export interface uxState {
  lightTheme: boolean;
  drawerOpen: boolean;
}

const initialState: uxState = {
  lightTheme: true,
  drawerOpen: false,
};

export const uxSlice = createSlice({
  name: 'ux',
  initialState,
  reducers: {
    toggleDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen;
    },
    setDrawer: (state, action) => {
      state.drawerOpen = action.payload;
    },
    toggleTheme: (state) => {
      state.lightTheme = !state.lightTheme;
    },
    setDrawerState: (state, payload) => {
      state.drawerOpen = payload.payload;
    },
  },
});

export const { toggleDrawer, toggleTheme, setDrawerState, setDrawer } =
  uxSlice.actions;

export default uxSlice.reducer;
